import {
  LanguageCode,
  ToolsOrganizations,
  ToolsProjects,
  Users,
} from '@prismo-io/schemas';
import { z } from 'zod';

export const ModeSchema = z.enum(['anon', 'full']);
export const TypeSchema = z.enum(['CV', 'TALENT', 'EXPERT']);

export type TypeSchemaT = z.infer<typeof TypeSchema>;
export type ModeSchemaT = z.infer<typeof ModeSchema>;

export const ParamsSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal(TypeSchema.Enum.CV),
    organization: ToolsOrganizations.pick({ id: true, email: true }).optional(),
    locale: LanguageCode.optional().default(LanguageCode.Enum.fr),
    users: Users.pick({ id: true, full_name: true }).array().min(1),
    mode: ModeSchema.optional().default(ModeSchema.Enum.full),
  }),
  z.object({
    type: z.literal(TypeSchema.Enum.TALENT),
    organization: ToolsOrganizations.pick({ id: true, email: true }),
    locale: LanguageCode.optional().default(LanguageCode.Enum.fr),
    users: Users.pick({ id: true, full_name: true }).array().min(1),
    mode: ModeSchema.optional().default(ModeSchema.Enum.full),
  }),
  z.object({
    type: z.literal(TypeSchema.Enum.EXPERT),
    organization: ToolsOrganizations.pick({ id: true, email: true }),
    locale: LanguageCode.optional().default(LanguageCode.Enum.fr),
    users: Users.pick({ id: true, full_name: true }).array().min(1),
    mode: ModeSchema.optional().default(ModeSchema.Enum.full),
  }),
]);

export type ParamsSchemaT = z.input<typeof ParamsSchema>;

export type Config = {
  cv?: { visible: boolean; disabled?: boolean };
  talent?: { visible: boolean; disabled?: boolean };
  expert?: { visible: boolean; disabled?: boolean };
  mode?: 'anon' | 'full' | 'all';
  canChooseLocale?: boolean;
};

export const DEFAULT_CONFIG: Config = {
  cv: { visible: false, disabled: true },
  talent: { visible: false, disabled: true },
  expert: { visible: false, disabled: true },
  mode: 'full',
  canChooseLocale: false,
};
